import { render, staticRenderFns } from "./renewBooking.vue?vue&type=template&id=2a6a8154&scoped=true&"
import script from "./renewBooking.vue?vue&type=script&lang=js&"
export * from "./renewBooking.vue?vue&type=script&lang=js&"
import style0 from "./renewBooking.vue?vue&type=style&index=0&id=2a6a8154&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6a8154",
  null
  
)

export default component.exports